var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyNew(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "33px",
    viewBox: "0 0 27 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Membership-subscription",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "00-My-Account-Corporate-Subscribed",
    transform: "translate(-326.000000, -542.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(165.000000, 533.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(161.351000, 9.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0.649 0 24.649 0 24.649 24 0.649 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.649,6 L7.649,3 C7.649,2.44771525 8.09671525,2 8.649,2 L20.649,2 C21.2012847,2 21.649,2.44771525 21.649,3 L21.649,17 C21.649,17.5522847 21.2012847,18 20.649,18 L17.649,18 L17.649,21 C17.649,21.552 17.199,22.000018 16.642,22.000018 L4.656,22.000018 C4.38965346,22.0015966 4.13365319,21.8969771 3.94465863,21.7092963 C3.75566406,21.5216155 3.6492613,21.2663512 3.649,21 L3.652,7 C3.652,6.448 4.102,6 4.659,6 L7.649,6 Z M5.652,8 L5.649,20 L15.649,20 L15.649,8 L5.652,8 Z M9.649,6 L17.649,6 L17.649,16 L19.649,16 L19.649,4 L9.649,4 L9.649,6 Z",
    id: "Shape",
    fill: "#222222",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "COPY",
    transform: "translate(0.000000, 25.592000)",
    fill: "#222222",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.411,6.516 C2.769,6.516 2.1885,6.3765 1.6695,6.0975 C1.1505,5.8185 0.7425,5.4315 0.4455,4.9365 C0.1485,4.4415 0,3.882 0,3.258 C0,2.634 0.1485,2.0745 0.4455,1.5795 C0.7425,1.0845 1.1505,0.6975 1.6695,0.4185 C2.1885,0.1395 2.772,0 3.42,0 C3.966,0 4.4595,0.096 4.9005,0.288 C5.3415,0.48 5.712,0.756 6.012,1.116 L5.076,1.98 C4.65,1.488 4.122,1.242 3.492,1.242 C3.102,1.242 2.754,1.3275 2.448,1.4985 C2.142,1.6695 1.9035,1.908 1.7325,2.214 C1.5615,2.52 1.476,2.868 1.476,3.258 C1.476,3.648 1.5615,3.996 1.7325,4.302 C1.9035,4.608 2.142,4.8465 2.448,5.0175 C2.754,5.1885 3.102,5.274 3.492,5.274 C4.122,5.274 4.65,5.025 5.076,4.527 L6.012,5.391 C5.712,5.757 5.34,6.036 4.896,6.228 C4.452,6.42 3.957,6.516 3.411,6.516 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.709,6.516 C9.055,6.516 8.4655,6.375 7.9405,6.093 C7.4155,5.811 7.0045,5.4225 6.7075,4.9275 C6.4105,4.4325 6.262,3.876 6.262,3.258 C6.262,2.64 6.4105,2.0835 6.7075,1.5885 C7.0045,1.0935 7.4155,0.705 7.9405,0.423 C8.4655,0.141 9.055,0 9.709,0 C10.363,0 10.951,0.141 11.473,0.423 C11.995,0.705 12.406,1.0935 12.706,1.5885 C13.006,2.0835 13.156,2.64 13.156,3.258 C13.156,3.876 13.006,4.4325 12.706,4.9275 C12.406,5.4225 11.995,5.811 11.473,6.093 C10.951,6.375 10.363,6.516 9.709,6.516 Z M9.709,5.274 C10.081,5.274 10.417,5.1885 10.717,5.0175 C11.017,4.8465 11.2525,4.608 11.4235,4.302 C11.5945,3.996 11.68,3.648 11.68,3.258 C11.68,2.868 11.5945,2.52 11.4235,2.214 C11.2525,1.908 11.017,1.6695 10.717,1.4985 C10.417,1.3275 10.081,1.242 9.709,1.242 C9.337,1.242 9.001,1.3275 8.701,1.4985 C8.401,1.6695 8.1655,1.908 7.9945,2.214 C7.8235,2.52 7.738,2.868 7.738,3.258 C7.738,3.648 7.8235,3.996 7.9945,4.302 C8.1655,4.608 8.401,4.8465 8.701,5.0175 C9.001,5.1885 9.337,5.274 9.709,5.274 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.781,0.108 C17.339,0.108 17.8235,0.201 18.2345,0.387 C18.6455,0.573 18.962,0.837 19.184,1.179 C19.406,1.521 19.517,1.926 19.517,2.394 C19.517,2.856 19.406,3.2595 19.184,3.6045 C18.962,3.9495 18.6455,4.2135 18.2345,4.3965 C17.8235,4.5795 17.339,4.671 16.781,4.671 L15.512,4.671 L15.512,6.408 L14.054,6.408 L14.054,0.108 L16.781,0.108 Z M16.7,3.483 C17.138,3.483 17.471,3.3885 17.699,3.1995 C17.927,3.0105 18.041,2.742 18.041,2.394 C18.041,2.04 17.927,1.7685 17.699,1.5795 C17.471,1.3905 17.138,1.296 16.7,1.296 L15.512,1.296 L15.512,3.483 L16.7,3.483 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "23.376 4.176 23.376 6.408 21.918 6.408 21.918 4.158 19.479 0.108 21.027 0.108 22.71 2.907 24.393 0.108 25.824 0.108"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyNew);
export default __webpack_public_path__ + "static/media/copy_new.bff41e4af59cafc51febd6fd9b76e514.svg";
export { ForwardRef as ReactComponent };